/* eslint-disable react/jsx-props-no-spreading */
import React, { memo, useContext } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';

import { RowFieldWrapper, ContainerForFieldInRow } from './add-row.styled';
import { FormContext } from '../../../shared/contexts/form-context';
import { ControlPropType } from '../../ctrl_proptype';
import RowFieldIcons from './rowIcon';

const FieldInRow = ({ id, ctrl, AllowedField, index, formDesign }) => {
  const { inBuilder } = useContext(FormContext);
  return (
    <ContainerForFieldInRow>
      {inBuilder ? (
        <>
          <Draggable draggableId={id} index={index}>
            {(provided, snapshot) => (
              <RowFieldWrapper
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                isDragging={snapshot.isDragging}
                style={{
                  ...provided.draggableProps.style,
                }}>
                <AllowedField ctrl={ctrl} formDesign={formDesign} />
              </RowFieldWrapper>
            )}
          </Draggable>
          <RowFieldIcons ctrl={ctrl} />
        </>
      ) : (
        <AllowedField ctrl={ctrl} formDesign={formDesign} />
      )}
    </ContainerForFieldInRow>
  );
};

FieldInRow.defaultProps = {
  formDesign: null,
};

FieldInRow.propTypes = {
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  AllowedField: PropTypes.func.isRequired,
  ctrl: PropTypes.shape(ControlPropType).isRequired,
};

export default memo(FieldInRow);
